import React, { useState, useEffect } from 'react'
import LoadingIndicator from '@/components/LoadingIndicator'
import context from '@/context'

const emptyApplicationFlags = {
  rfc13Announcements: false,
  rfc13AllTasks: false,
  rfc13MessagesModule: false
}

export const FeatureFlagsContext = React.createContext(emptyApplicationFlags)

export function FeatureFlagsProvider ({ children }) {
  const [applicationFlags, setApplicationFlags] = useState(emptyApplicationFlags)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadFeatureFlags = async () => {
      try {
        const flags = await context.api.configurationService.getApplicationFlags()
        setApplicationFlags(flags || emptyApplicationFlags)
      } catch (error) {
        console.error('Failed to load feature flags:', error)
        // Default to empty flags on error
        setApplicationFlags(emptyApplicationFlags)
      } finally {
        setIsLoading(false)
      }
    }

    loadFeatureFlags()
  }, [])

  if (isLoading) {
    return <LoadingIndicator />
  }

  return (
    <FeatureFlagsContext.Provider value={applicationFlags}>
      {children}
    </FeatureFlagsContext.Provider>
  )
}



// WEBPACK FOOTER //
// ./src/components/featureFlagsProvider.js